<template>
  <div class="search-header-wrapper-bg">
    <div class="content">
      <div class="left">
        <slot name="left"></slot>
      </div>
      <div class="right">
        <customInput
          v-model="modelValue"
          @handleSearch="handleSearch"
        ></customInput>
      </div>
    </div>
  </div>
</template>

<script>
import customInput from './custom-input.vue'
export default {
  name: 'search-header',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  components: {
    customInput,
  },
  data() {
    return {}
  },
  methods: {
    handleSearch() {
      this.$emit('handleSearch')
    },
  },
  mounted() {},
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
}
</script>

<style scoped lang="scss">
.search-header-wrapper-bg {
  width: 100%;
  height: 84px;
  background-color: linear-gradient(90deg, #dce9ff80 0%, #f6f6ff80 100%);
  background:url('~@/assets/image/zhenyunOrder/head.png') no-repeat center 100%;
      background-size: 100% 100%;
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    height: 100%;
    .right {
    }
  }
}
</style>
